import { builder } from 'common/js/configs';

const overriddenCommonFormatConfigUnmarshaller = {
  triggerImpressionAfterPreload: builder.boolean(
    'trigger_impression_after_preload',
    {
      l:'',
      d:'',
      defaultValue: true
    }
  )
};

export const formatConfigUnmarshaller = {
  ...overriddenCommonFormatConfigUnmarshaller,
  monitoringEnabled: builder.boolean('monitoring_enabled', {
    defaultValue: false
  }),
  analyticsSsp: builder.holder({
    enable: builder.boolean('analytics_ssp_enable', {
      l:'',
      d:'',
      defaultValue: false
    })
  }),
  interaction: builder.string('interaction', {
    of: ['touch', 'click'],
    possibleValues: [
      {
        name: 'Touch',
        value: 'touch'
      },
      {
        name: 'Click',
        value: 'click'
      }
    ],
    defaultValue: 'click',
    d:''
  }),
  shouldSendCloseCreativeTrack: builder.boolean('close_creative_track_enable', {
    defaultValue: false,
    d:'',
    l:''
  })
};

export interface ImageConfigType {
  previewIsBackgroundColored: string;
  discoverFontColor: string;
  backgroundColor: string;
  creative: CreativeConfigType;
  cta: CtaConfigType;
  brand?: BrandBarConfigType;
  confirmButton: ConfirmButtonConfigType;
  discover: DiscoverConfigType;
  blurEffect: BlurEffectConfigType;
  interaction: 'touch' | 'click';
  name: string;
  shouldSendCloseCreativeTrack: boolean;
}
